import React, {useEffect, useState} from "react";
import {Ajax} from "../Service/ajax";
import {ClipLoader} from "react-spinners";
import {useLocation, useNavigate} from "react-router-dom";
import {convertDate} from "../config/AppConfig"
import Swal from "sweetalert2";

export default function PaymentCheckView(){
    const location = useLocation();
    const success = location.state?.success;
    const error = location.state?.errors;
    const searchParams = new URLSearchParams(location.search);
    const trs=searchParams.get('trs');
    const [loading, setLoading]=useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData= async ()=>{
            try {
                setLoading(true);
                const {data} =await Ajax.getRequest("/api/v1/sub/subscription/payment/check-payment/"+trs)
                if(data.error){
                    Swal.fire({
                        title: 'Error!',
                        text: data.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000,
                        timerProgressBar: true,
                        didClose: () => {
                            window.location.replace(window.location.origin);
                        }
                    });
                }else{
                    if(data.object.confirm_at !== null){
                        let period;
                        switch (data.object.prd) {
                            case 'DAILY':
                                period = "Journalier";
                                break;
                            case 'WEEKLY':
                                period = "Semestriel";
                                break;
                            case 'MONTHLY':
                                period = "Mensuel";
                                break;
                            case 'ANNUAL':
                                period = "Annuel";
                                break;
                            default:
                                period = null;
                        }
                        Swal.fire({
                            title: 'Success!',
                            text: "Vous venez de souscrire au pack "+period+" "+data.object.sub+" de "+data.object.cmp,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            didClose: () => {
                                window.location.replace(window.location.origin+"/particulier");
                            }
                        });
                    }
                    if(data.object.abort_at !== null){
                        Swal.fire({
                            title: 'Annulation!',
                            text: "Votre souscription au pack "+data.object.sub+" de "+data.object.cmp +" a été annulé avec succès",
                            icon: 'info',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            didClose: () => {
                                window.location.replace(window.location.origin);
                            }
                        });
                    }
                    if(data.object.abort_at === null && data.object.confirm_at === null){
                        Swal.fire({
                            title: 'Erreur!',
                            text: "Votre souscription au pack "+data.object.sub+" de "+data.object.cmp +" a échoué.",
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000,
                            timerProgressBar: true,
                            didClose: () => {
                                window.location.replace(window.location.origin);
                            }
                        });
                    }
                }
            }catch (error){
                Swal.fire({
                    title: 'Error!',
                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }finally {
                setLoading(false);
            }
        }
        if(success){
            const data = JSON.parse(success);
            const {plan} = data;
            const {application} =plan;
            Swal.fire({
                title: 'Success!',
                text: "Vous venez de souscrire au pack "+plan.title+" de "+application.title +". Abonnement valide jusqu'au "+convertDate(data.endDate),
                icon: 'success',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000,
                timerProgressBar: true,
                didClose: () => {
                    window.location.replace(window.location.origin);
                }
            });
        }else if(error){
            Swal.fire({
                title: 'Error!',
                text: "Une erreur s'est produite pendant la souscription à l'abonnement, veillez reessayez plus tard",
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000,
                didClose: () => {
                    window.location.replace(window.location.origin);
                }
            });
        } else if (searchParams.has("trs")){
            fetchData();
        }else{
            window.location.replace(window.location.origin);
        }
    }, []);
    return(
        <div>
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <ClipLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div>

                </div>
            )}
        </div>
    );
}
